import React from "react";

const ITEMS = [
  { title: "What you get", body: "A draft assessment of likely fit and risk points for the workflow you describe, shown on screen and sent to your email." },
  { title: "Who follows up", body: "Our team is notified of your request and can follow up with you by email." },
  { title: "What we need", body: "Name, work email, workflow type, and a short description. Everything else is optional, and no documents are required." },
];

export default function IntakeExpectations() {
  return (
    <div className="grid sm:grid-cols-3 gap-3 mb-5">
      {ITEMS.map((item) => (
        <div key={item.title} className="rounded-xl border border-border bg-muted/30 p-4">
          <p className="text-sm font-semibold text-foreground mb-1">{item.title}</p>
          <p className="text-xs text-muted-foreground leading-relaxed">{item.body}</p>
        </div>
      ))}
    </div>
  );
}